<style src="./EventRms.scss" lang="scss"></style>
<template>
  <main class="event-rms">
    <content-header path="Documentos"/>
    
    <item-documents
      :items="items"
      :event-date="eventDetails.date && eventDetails.date.event"
      class="col-8" />
  </main>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import ItemDocuments from './components/item-documents/ItemDocuments'

export default {
  name: 'EventRms',
  components: {
    ContentHeader,
    ItemDocuments
  },
  data: () => ({
    eventDetails: {
      date: null
    },
    documents: [],
    items: []
  }),
  mounted () {
    this.loadEvent()
  },
  methods: {
    async loadEvent () {
      const payload = {
        eventId: this.$route.params.id
      }

      try {
        const { eventDetails, eventItems } = await this.$store.dispatch('Rms/LOAD_EVENT', payload)
        this.items = eventItems
        this.eventDetails = eventDetails
      } catch (error) {
        return Error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-rms/EventRms.vue